// extracted by mini-css-extract-plugin
export default {"wrap":"Favorite_wrap__OscqW"};